var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinishonb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 22,
    viewBox: "0 0 40 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4675 0.532533C40.1775 1.24258 40.1775 2.39379 39.4675 3.10383L21.2856 21.2856C20.5756 21.9957 19.4244 21.9957 18.7143 21.2856L17.578 20.1493C16.8679 19.4392 16.8679 18.288 17.578 17.578C18.2375 16.9184 19.2777 16.8715 19.9914 17.4373L36.8962 0.532533C37.6062 -0.177511 38.7574 -0.177511 39.4675 0.532533ZM9.62344 9.62344C10.3335 8.9134 11.4847 8.9134 12.1947 9.62344L13.3311 10.7598C14.0411 11.4698 14.0411 12.6211 13.3311 13.3311C12.6211 14.0411 11.4698 14.0411 10.7598 13.3311L9.62344 12.1947C8.9134 11.4847 8.9134 10.3335 9.62344 9.62344Z",
    fill: "#CBCBCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3766 0.532533C31.0866 1.24258 31.0866 2.39379 30.3766 3.10383L12.1947 21.2856C11.4847 21.9957 10.3335 21.9957 9.62344 21.2856L0.532533 12.1947C-0.177511 11.4847 -0.177511 10.3335 0.532533 9.62344C1.24258 8.9134 2.39379 8.9134 3.10383 9.62344L10.9091 17.4287L27.8053 0.532533C28.5153 -0.177511 29.6665 -0.177511 30.3766 0.532533Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishonb);
export default __webpack_public_path__ + "static/media/finishonb.87fb1988b7234b08e93ee28c3cfcc10a.svg";
export { ForwardRef as ReactComponent };